const FormInput = props => {
    const { type, label, required, ErrorMessage, register, name, id, errors } =
        props;
    return (
        <div className='form-group mb-3'>
            <label className='text-black font-w500' htmlFor={id}>
                {label}
                {required && <span className='text-danger'>*</span>}
            </label>
            <div className='col-lg-12'>
                <input
                    type={type || 'text'}
                    id={id}
                    className='form-control'
                    {...register}
                />
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => (
                        <div className='text-danger fs-12'>{message}</div>
                    )}
                />
            </div>
        </div>
    );
};

export default FormInput;
